import React from 'react';
import PropTypes from 'prop-types';
import './Record.css';

const Record = ({
    record,
    uniqueKey,
    handleStartUpload,
    handlePauseUpload,
    setDetailsForDeleteRecordModal
}) => {
    const {
        name,
        status,
        percentage,
        size,
        date,
        time
    } = record;

    const formattedDate = date ? date.replaceAll("-", "/") : '';
    const formattedTime = time ? time.slice(0, time.length - 3).replace("-", ":") : '';
    const formattedSize = size ? parseFloat(size).toFixed(2) : '0.00';

    const getActionButton = () => {
        if (status === 3) {
            return null;
        }

        const actionProps = {
            0: { icon: "vertical_align_bottom", handler: () => handleStartUpload(name), title: "Start Upload" },
            1: { icon: "pause", handler: () => handlePauseUpload(name), title: "Pause Upload" },
            2: { icon: "play_arrow", handler: () => handleStartUpload(name), title: "Resume Upload" }
        };

        const config = actionProps[status];
        if (!config) return null;

        return (
            <button
                className='action-btn'
                onClick={(e) => { e.stopPropagation(); config.handler(); }}
                title={config.title}
            >
                <span className='material-icons'>{config.icon}</span>
            </button>
        );
    };

    return (
        <div key={uniqueKey} className="record-card">
            <div className="record-main-content">
                <div className="record-icon-wrapper">
                    <i className="material-icons record-icon">videocam</i>
                </div>

                <div className="record-info-wrapper">
                    <div className="record-header">
                        <div className="record-title" title={name}>{name}</div>
                        {(status === 1 || status === 2) && (
                            <span className="download-status-text header-status">
                                <i className="material-icons header-status-icon">download</i>
                                {percentage || 0}%
                            </span>
                        )}
                    </div>

                    <div className="record-meta">
                        <span className="meta-item">
                            <i className="material-icons meta-icon">data_usage</i>
                            {formattedSize}MB
                        </span>
                        <span className="meta-separator">|</span>
                        <span className="meta-item">
                            <i className="material-icons meta-icon">event</i>
                            {formattedDate}
                        </span>
                        <span className="meta-separator">|</span>
                        <span className="meta-item">
                            <i className="material-icons meta-icon">access_time</i>
                            {formattedTime}
                        </span>
                    </div>
                </div>
            </div>

            <div className="record-actions">
                {status === 3 && (
                    <button className='action-btn success' disabled title="Uploaded">
                        <span className='material-icons'>check_circle</span>
                    </button>
                )}

                {getActionButton()}

                <button
                    className='action-btn delete'
                    disabled={status === 1}
                    onClick={(e) => { e.stopPropagation(); setDetailsForDeleteRecordModal(name); }}
                    title="Delete Record"
                >
                    <span className='material-icons'>delete_outline</span>
                </button>
            </div>

            {/* Linear Progress Bar (Absolute Bottom) */}
            {(status === 1 || status === 2) && (
                <div className="linear-progress-container">
                    <div
                        className="progress-fill"
                        style={{ width: `${percentage || 0}%` }}
                    ></div>
                </div>
            )}
        </div>
    );
};

Record.propTypes = {
    record: PropTypes.object.isRequired,
    uniqueKey: PropTypes.string.isRequired,
    handleStartUpload: PropTypes.func.isRequired,
    handlePauseUpload: PropTypes.func.isRequired,
    setDetailsForDeleteRecordModal: PropTypes.func.isRequired,
};

export default Record;
